
interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function SectionCard({ children, className }: Props) {
  const classes = [
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={classes}>
      {children}
    </section>
  );
}
